<template>
    <div class="full-height-container ps-2">

        <div class="d-flex">

            <div class="d-flex align-items-center" v-if="model.app.tables.length > 0 ">
                <router-link :to="{ name: 'new-table', params: {app_id: model.app.id}}"
                             class="badge text-bg-primary mx-1">Create new table
                </router-link>
            </div>

        </div>

        <div v-if="model.app.tables.length > 0">
            <div v-for="table in model.app.tables" class="card mb-2">
                <table-details :table="table"></table-details>
            </div>
        </div>

        <div v-else class="mt-2">
            <div class="alert alert-primary mb-4" role="alert">
                <h4 class="alert-heading">Data models are what power your application</h4>
                <p>A data model can be anything: a Car, a Recipe, a Job.  They represent the "things" in your
                    application in the form of data.</p>
                <p class="mb-0">Create your own custom data model OR use one of our pre-built templates</p>
            </div>

            <router-link :to="{ name: 'new-table', params: {app_id: model.app.id}}"
                         class="btn btn-primary">Create Data Model
            </router-link>

            <div class="my-3">
                <data-model-templates></data-model-templates>
            </div>
        </div>

        <confirm-modal
                v-if="showConfirmModal"
                @noEvent="showConfirmModal = false"
                :yesEvent="deleteTable"
                text="Are you sure you want to delete this table?">
        </confirm-modal>
    </div>
</template>

<script>
    import AppService from "../../services/AppService";
    import ConfirmModal from "../../components/ConfirmModal.vue";
    import ModelService from "../../services/ModelService";
    import ArrayUtil from "../../utils/ArrayUtil";
    import TableDetails from "./TableDetails.vue";
    import AppDisplay from "../../components/AppDisplay.vue";
    import DataModelTemplates from "../../marketplace/DataModelTemplates.vue";

    export default {
        name: 'AppEditor',
        components: {DataModelTemplates, AppDisplay, TableDetails, ConfirmModal},
        data() {
            return {
                model: webase.model,
                currentTable: null,
                currentField: null,
                service: new AppService(),
                arrayUtil: new ArrayUtil(),
                showConfirmModal: false,
                deleteTable: function () {
                },
                invite: {
                    email: ''
                }
            }
        },
        mounted() {
            if (this.$route.params.id) {
                let appId = this.$route.params.id

                this.service.initApp(appId).then((response) => {
                    this.model.app = response

                    if(this.model.app.tables.length > 0) {
                        this.$router.push({ name: 'open-app', params: {id: this.model.app.id}})
                    }
                }).catch((message) => {
                    console.log('error loading app')
                    console.log(message)
                })
            }
        },
        methods: {
            onDeleteClick(tableId) {
                let modelService = new ModelService()
                this.showConfirmModal = true
                this.deleteTable = () => {

                    modelService.remove(tableId).then(() => {
                        this.arrayUtil.remove(this.model.app.tables, tableId)
                        this.showConfirmModal = false
                    }).catch((error) => {
                        console.log('Error removing table.')
                        console.log(error)
                        this.showConfirmModal = false
                    })
                }
            },
            onInviteClick() {
                let appService = new AppService();
                let site = window.location.hostname
                appService.inviteUserToCollaborate(this.invite.email, this.model.app.id, site).then((response) => {
                    //$('#dropdownMenuButton').dropdown('toggle')
                    //this.messageUtil.success('Invitation sent.')
                    this.invite.email = ''
                }).catch((error) => {
                    //this.messageUtil.error('Error sending invitation, message: ' + error)
                })
            }
        }
    }
</script>

<style>

</style>
